import { Controller } from "@hotwired/stimulus"
import { gantt } from "dhtmlx-gantt"

export default class extends Controller {
  static targets = [ "container" ]
  static values = { entry: String }

  connect() {
    gantt.i18n.setLocale("ru");
    gantt.locale.labels.section_owner = "Исполнитель";

    gantt.config.date_format = "%Y-%m-%d %H:%i:%s";
    this.initZoom();
    gantt.config.server_utc = true;
    gantt.config.min_column_width = 40;

    const textEditor = { type: "text", map_to: "text" };
    const startDateEditor = { type: "date", map_to: "start_date" };

    gantt.config.scales = [
      { unit: "month", step: 1, format: "%F %Y" },
      { unit: "day", step: 1, format: "%j.%m" }
    ];

    gantt.config.columns = [
      { name: "text", label: "Задача", width: 260, tree: true, resize: true, editor: textEditor },
      { name: "readable_id", label: "ID", width: 100, align: "center", template: function (task) {
          return task.readable_id ? `<a href="/entries/${task.readable_id}">${task.readable_id}</a>` : "";
        } },
      { name: "start_date", label: "Дата", width: 120, align: "center", resize: true, editor: startDateEditor,
        template: function (task) {
          if (!task.start_date) return "";
          const options = { year: "numeric", month: "numeric", day: "numeric" };
          return task.start_date.toLocaleDateString("ru", options);
        }
      },
      { name: "owner_id", label: "Исполнитель", width: 150, resize: true,
        template: function (task) {
          if (task.owner_id) {
            const users = gantt.serverList("users") || [];
            const owner = users.find(user => user.key == task.owner_id);
            return owner ? owner.label : "N/A";
          }
          return "";
        }
      },
      { name: "add", label: "", width: 44 }
    ];

    gantt.config.lightbox.sections = [
      { name: "description", height: 70, map_to: "text", type: "textarea", focus: true },
      { name: "owner", height: 52, map_to: "owner_id", type: "select", options: gantt.serverList("users") },
      { name: "time", height: 72, map_to: "auto", type: "duration" }
    ];

    gantt.templates.task_text = (start, end, task) => {
      return `${task.readable_id || ''} ${task.text || ''}`.trim();
    };

    gantt.templates.task_class = (start, end, task) => {
      if (task.progress === 1) return "gantt-task-completed";
    };

    gantt.init(this.containerTarget);

    gantt.load(`/api/entries/${this.entryValue}/data`);

    this.dp = new gantt.dataProcessor(`/api`);
    this.dp.init(gantt);
    this.dp.setTransactionMode("REST");

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');
    if (csrfToken) {
      this.dp.attachEvent("onBeforeXLSending", (connection, action, xml) => {
        connection.setRequestHeader("X-CSRF-Token", csrfToken);
        return true;
      });
    }
  }

  disconnect() {
    if (this.dp) {
      this.dp.destructor();
      this.dp = null;
    }
    gantt.clearAll();
  }

  initZoom() {
    const zoomConfig = {
      levels: [
        {
          name: "day",
          scale_height: 50,
          min_column_width: 80,
          scales: [{ unit: "day", step: 1, format: "%d %M" }]
        },
        {
          name: "week",
          scale_height: 50,
          min_column_width: 50,
          scales: [
            { unit: "week", step: 1, format: "Неделя %W" },
            { unit: "day", step: 1, format: "%d" }
          ]
        },
        {
          name: "month",
          scale_height: 50,
          min_column_width: 120,
          scales: [
            { unit: "month", step: 1, format: "%F, %Y" },
            { unit: "week", step: 1, format: "Нед %W" }
          ]
        }
      ]
    };

    gantt.ext.zoom.init(zoomConfig);
    gantt.ext.zoom.setLevel("week");
  }

  zoomIn() {
    gantt.ext.zoom.zoomIn();
  }

  zoomOut() {
    gantt.ext.zoom.zoomOut();
  }
}
